<template>
  <div class="question-container" style="width:90%; padding-top: 20px;">
    <b-row style="padding-bottom: 5px">
      <b-col sm="2"> Measure Family</b-col>
      <b-col sm="4">
        <b-form-select v-model="measureFamily" :options="measureFamilies" v-on:change="selectQuestionFamily"
                       @selected="selectPage">
        </b-form-select>
      </b-col>
    </b-row>
    <b-row style="padding-bottom: 5px">
      <b-col sm="2"> Assigned Page</b-col>
      <b-col sm="6">
        <input type="hidden" name="questionId" class="form-control" :value="id">

        <b-form-select v-model="selectedPage" :options="pages" v-on:change="selectPage"
                       @selected="selectPage" :disabled="isAssignedPageEnabled">
        </b-form-select>
      </b-col>
    </b-row>
    <b-row style="padding-bottom: 5px">
      <b-col sm="2"> Question Type</b-col>
      <b-col sm="6">
        <b-form-select v-model="controlType" :options="controlTypeOptions" @changed="changedLabel"
                       @selected="changedLabel" :disabled="isControlTypeEnabled">
        </b-form-select>
      </b-col>
    </b-row>
    <b-row style="padding-bottom: 5px">
      <b-col sm="2"> Category</b-col>
      <b-col sm="6">
        <b-form-select v-model="type" :options="typeOptions" @changed="changedLabel"
                       @selected="changedLabel" :disabled="isCategoryEnabled">
        </b-form-select>
      </b-col>
    </b-row>
    <hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">
    <div>
      <b-card bg-variant="light">
        <div>
          <b-form-group label-cols="4" label-cols-lg="2" label-size="sm" label="Question Name:" label-for="input-sm">
            <b-form-input id="input-sm" size="sm" v-model="name" placeholder="Question Name"></b-form-input>
          </b-form-group>
        </div>

        <div>
          <b-form-group label-cols="2" label-cols-lg="2" label-size="md" label="Text:" label-for="input-sm">
            <b-form-textarea rows="4" id="input-sm" size="sm" v-model="text"
                             placeholder="Question Text"></b-form-textarea>
          </b-form-group>
        </div>
      </b-card>
      <hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">
    </div>

    <div v-if="showMatrixQuestionProp">
      <b-card bg-variant="light">
        <b-form-group label="Columns">
          <ListControl v-model="columns"/>
        </b-form-group>
      </b-card>
    </div>

    <div v-if="showMultipleQuestionProp">
      <b-card bg-variant="light">
        <b-form-group label="Choices">
          <ListControl v-model="choices"/>
        </b-form-group>
      </b-card>
    </div>

    <div v-if="showMultipleQuestionProp">
      <br/>
      <b-input-group prepend="Number Of Columns" v-if="false">
        <b-form-input type="number" min="0.00" v-model="colCount"></b-form-input>

        <b-input-group-append>
          <b-btn variant="outline-info" @click="colCount--">-</b-btn>
          <b-btn variant="outline-secondary" @click="colCount++">+</b-btn>
        </b-input-group-append>
      </b-input-group>
      <hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">
    </div>

    <div v-if="showMultipleQuestionProp">
      <input type="hidden" v-model="hasNone"/>
    </div>
    <div v-if="showIfAnyQuestion">
      <div>
        <b-form-checkbox
            id="checkbox-1"
            v-model="isRequired"
            name="checkbox-1"
            value="true"
            label="Required"
            unchecked-value="false"
        >Required
        </b-form-checkbox>
      </div>
    </div>

    <div>
      <input type="submit" value="Submit" v-on:click="submit"/>
    </div>

  </div>
</template>
<script>
import ListControl from './ListControl'

export default {
  name: "CreateQuestion",
  components: {
    ListControl
  },
  data() {
    return {
      index: 1,
      controlType: null,
      controlTypeOptions: [
        {value: null, text: "Please Select A Question Type"},
        {value: "COMMENT", text: "TEXT"},
        {value: "MATRIX", text: "MATRIX"},
        {value: "CHECKBOX", text: "CHECKBOX"}
      ],
      selectedValue: null,
      selectedPage: null,
      placement: 'down',
      id: '',
      name: '',
      text: '',
      type: null,
      typeOptions: [
        {
          value: null,
          text: "Select Question Category"
        },
        {
          value: "CORE",
          text: "CORE"
        }, {

          value: "ELECTIVE",
          text: "ELECTIVE"
        }],
      creatorId: '',
      columns: ["Yes", "No", "N/A"],
      qnum: 0,
      hasNone: false,
      colCount: 1,
      choices: ['Question Option 1'],
      greenNote: '',
      pages: [{value: null, text: 'Please select an Page'}],
      isRequired: false,
      measureFamily: null,
      measureFamilies: [{value: null, text: 'Select A Measure Family'},
        {
          value: "VINEYARD",
          text: 'VINEYARD'
        },
        {
          value: "WINE",
          text: 'WINE'
        }
      ]
    }
  },
  watch: {
    months: function (newVal) {
      this.showStep(newVal);
    }
  },
  beforeRouteEnter(to, from, next) {
    // TODO Find out whether Vineyard Admins should be able to add/edit questions?
    let roles = localStorage.getItem("roles");
    if (roles.includes("admin")) {
      next();
    } else {
      next({name: "My Account"})
    }
  },
  mounted() {
    let self = this;
    /*    this.$http.get(`vineyard/survey/pages/names?${self.measureFamily}`)
            .then(response => {
              console.log(response.data);
              let values = []
              Object.entries(response.data)
                  .map(item => values.push({value: item[0], text: item[1]}));
              self.pages = self.pages.concat(values);
            })*/
  },
  computed: {
    showTextQuestionProp: function () {
      return this.controlType === "TEXT";
    },
    showMatrixQuestionProp: function () {
      return false;// this.controlType === "MATRIX";
    },
    showMultipleQuestionProp: function () {
      return this.controlType === "CHECKBOX";
    },
    showIfAnyQuestion: function () {
      return this.selectedValue !== null;
    },
    isAssignedPageEnabled: function () {
      return this.measureFamily === null;
    },
    isControlTypeEnabled: function () {
      return this.selectedPage === null;
    },
    isCategoryEnabled: function () {
      return this.controlType === null;
    }
  },
  methods:
      {
        updateParent: function (value_from_child) {
          alert(value_from_child);
        },
        loadPages: function () {
          let self = this;
          this.pages = [{value: null, text: 'Please select an Page'}];
          this.$http.get(`vineyard/survey/pages/names?type=${self.measureFamily}`)
              .then(response => {
                console.log(response.data);
                let values = []
                Object.entries(response.data)
                    .map(item => values.push({value: item[0], text: item[1]}));
                values.sort((a, b) => {
                  if (a.text < b.text) {
                    return -1;
                  }
                  if (a.text > b.text) {
                    return 1;
                  }
                  return 0;
                })
                self.pages = self.pages.concat(values);
                console.log(self.pages);
              })
        },
        isValueSelected: function (value) {
          let isNotNull = value !== null;
          let isEqualTo1 = (isNotNull && value.value === 2) || (isNotNull && value === 2);
          return isNotNull && isEqualTo1;
        },
        submit: function () {
          let self = this;
          console.log(this.firstName, this.lastName);
          let question = this.toChecklistQuestion();
          this.$http.post(`vineyard/measure/${this.selectedPage}?type=${this.measureFamily}`, question)
              .then(response => {
                console.debug(response.data);
                this.$toasted.info("Question Created Successfully", {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-check-circle',
                    after: false
                  }
                })
                    .goAway(5000);
                self.measureFamily = null;
                self.controlType = null;
                self.selectedPage = null;
                self.type = null;
                self.name = '';
                self.text = '';
                console.log("Resetting page for next question creation.")
              })

        },
        toChecklistQuestion: function () {
          return {
            controlType: this.controlType,
            section: this.selectedPage,
            name: this.name,
            text: this.text,
            type: this.type,
            columns: this.columns,
            qnum: 0,
            colCount: 1,
            choices: this.choices,
            greenNote: this.greenNote
          }
        },
        selectPage: function () {
          this.loadPages();
          this.name = this.pages.find(page => {
            return page.value === this.selectedPage
          }).text;
          console.debug("Label Value: " + this.name);
        },
        selectQuestionFamily: function () {
          this.loadPages();
          console.debug("Loading Pages");
        }
      }
}
</script>
<style>
div.question-container {
  padding-left: 50px;
}
</style>
